import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Header = styled.header`
  width: 100%;
  background-color: #FFF;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.4514285714285715rem;
  margin-left: auto;
  margin-right: auto;
  max-width: ${variables.MAX_WIDTH};
  
  img {
    width: 11.551428571428572rem;
  }
  
  @media(max-width: ${variables.TABLET}) {
      margin-left: ${variables.SPACING};
      margin-right: ${variables.SPACING};
      
      img {
        width: 5.402857142857143rem;
      }
  }
`;
